import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class HttpStatusNotifierService {
    private requestInFlight$: BehaviorSubject<boolean>;

    constructor(){
        this.requestInFlight$ = new BehaviorSubject(false);
    }
    setHttpStatus(inFlight: boolean){
        this.requestInFlight$.next(inFlight);
    }
    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight$.asObservable();
    }
}


// WEBPACK FOOTER //
// ./src/app/services/http-status-notifier.service.ts